// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../lib/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".placeholder[data-v-36fdab83]{background-color:#000000;padding-top:56.25%;position:relative;width:100%}.placeholder .player-content[data-v-36fdab83]{position:absolute;top:0;left:0;height:100%;width:100%}\n", ""]);
// Exports
module.exports = exports;
